import { UseIonAlertResult } from "@ionic/react";

export function showErrorAlert(useIonAlertResult: UseIonAlertResult, message: string) {
  const [present] = useIonAlertResult;
  present({
    cssClass: "ion-error-alert",
    header: "Error",
    message: message,
    buttons: ["Ok"],
  });
}
